import { heroEquipment } from "../HeroEquipment";

export const kislev = {
  heroes: {
    Bojar: {
      id: 0,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Zbrojna chorągiew z Kisleva"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Dowódca"],
      exp: 20,
      skills: [0, 1, 2, 3, 4, 5],
    },
    "Magister Lodu": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Zbrojna chorągiew z Kisleva"].Magister,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mag (Tradycja Lodu)"],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    "Kapłan Ursuna": {
      id: 2,
      startingEquipment: ["Sztylet", "Topór bojowy/Nadziak"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Zbrojna chorągiew z Kisleva"].Kapłan,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Czarostwo",
        "Duchowny (modlitwy do Ursuna)",
        "Modlitwa",
        "Pogarda",
        "Rozproszenie magii (2)",
      ],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    Sierżant: {
      id: 3,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Zbrojna chorągiew z Kisleva"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Podoficer"],
      exp: 8,
      skills: [0, 1, 3, 4, 5],
    },
    Treser: {
      id: 4,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Zbrojna chorągiew z Kisleva"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Treser"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    Adiutant: {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 15,
      number: 1,
      equipmentList: heroEquipment["Zbrojna chorągiew z Kisleva"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 6],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Adiutant", "Przyboczny"],
      exp: 0,
      skills: [0, 1, 4, 5],
    },
    Zbrojny: {
      id: 6,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Zbrojna chorągiew z Kisleva"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści", "Drużyna obsługi", "Drużyna wsparcia"],
    },
    Kozak: {
      id: 7,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 30,
      number: 5,
      equipmentList: heroEquipment["Zbrojna chorągiew z Kisleva"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Szermierz"],
    },
    Myśliwy: {
      id: 8,
      startingEquipment: ["Sztylet", "Łuk"],
      cost: 20,
      number: 7,
      equipmentList: heroEquipment["Zbrojna chorągiew z Kisleva"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Ranger", "Zwiadowca"],
    },
    Husarz: {
      id: 9,
      startingEquipment: [
        "Sztylet",
        "Miecz",
        "Włócznia",
        "Koń bojowy",
        "Siodło & uprząż",
      ],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Zbrojna chorągiew z Kisleva"].Husarz,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: [
        "Duży cel (wierzchem)",
        "Kawalerzysta",
        "Strach",
        "Zabójczy cios",
      ],
    },
    Nomada: {
      id: 10,
      startingEquipment: [
        "Sztylet",
        "Miecz",
        "Łuk krótki",
        "Koń bojowy",
        "Siodło & uprząż",
      ],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Zbrojna chorągiew z Kisleva"].Nomada,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Kawalerzysta", "Lekka jazda", "Ranger", "Zwiadowca"],
    },
    Niedźwiedź: {
      id: 11,
      startingEquipment: ["Broń naturalna"],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 4, 0, 5, 4, 3, 4, 3, 6],
        Maksymalna: [6, 4, 0, 5, 4, 3, 4, 3, 6],
      },
      rules: ["Bestia", "Głód trzewi", "Potwór", "Zwiadowca", "Zwierzę"],
    },
    Zaprzęg: {
      id: 12,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Kontakty handlowe (3)", "Machina wojenna", "Powóz"],
    },
    Rydwan: {
      id: 13,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Zbrojna chorągiew z Kisleva",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (2)", "Podatek"],
  mercenaries: [
    "Balistyk",
    "Bombardier",
    "Gladiator",
    "Goniec",
    "Kartograf",
    "Kupiec",
    "Łowca nagród",
    "Magus",
    "Medyk",
    "Minstrel",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Pogromca Trolli",
    "Poszukiwacz złota",
    "Rozbójnik",
    "Rycerz najemny",
    "Skryba",
    "Strażnik dróg",
    "Szczurołap",
    "Szpieg",
    "Tileański kusznik",
    "Trefniś",
    "Woźnica",
    "Wróżbita",
    "Złodziej",
    "Zwadźca",
    "Zwiadowca",
  ],
};
